import { Box, Slider } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { SyntheticEvent } from 'react';

type SliderValue = number | number[];

interface TimeSliderProps {
    value: SliderValue;
    onChange?: (event: Event, newValue: SliderValue) => void;
    onChangeCommitted?: (event: Event | SyntheticEvent<Element, Event>, newValue: SliderValue) => void;
    /**
     * Optional styles for the Box container. Merged over defaults.
     */
    containerSx?: SxProps<Theme>;
    /**
     * Optional Box width system prop. Defaults to "3" to keep previous behavior.
     */
    boxWidth?: number | string;
}

const defaultContainerSx: SxProps<Theme> = { width: 300, padding: '20px', margin: 'auto', textAlign: 'center' };

function valuetext(value: number) {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const RangeSlider = ({ value, onChange, onChangeCommitted, containerSx, boxWidth }: TimeSliderProps) => (
    <Box
        sx={containerSx ?? defaultContainerSx}
        width={boxWidth ?? '3'}
    >
        <Slider
            value={value}
            onChange={onChange}
            onChangeCommitted={onChangeCommitted}
            valueLabelDisplay="off"
            min={0}
            // Allow selecting the true end-of-day 11:59 PM (1439 minutes)
            max={1439}
            step={1}
            sx={{ color: '#1976d2' }}
            getAriaValueText={valuetext}
            valueLabelFormat={valuetext}
        />
    </Box>
);

export default RangeSlider;
